import {
  TestCaseFullScreenCloseCallbackData,
  TestCaseFullScreenModalData,
} from '@qality/common-model/src/TestCaseFullScreenData';

export default {
  openTestCaseFullScreenDialog(customData: TestCaseFullScreenModalData): void {
    window.AP.dialog
      .create({
        key: 'test-case-full-screen-dialog',
        size: 'maximum',
        chrome: false,
        customData,
        closeOnEscape: false,
      })
      .on('close', (data: TestCaseFullScreenCloseCallbackData) => {
        customData.onFullScreenClose(data);
      });
  },
};
